(function ($) {
  if (document.readyState !== "loading") {
     main_init();
  } else {
     document.addEventListener("DOMContentLoaded", function () {
        main_init();
     });
  }
  function main_init() {
     $("swiper-container").each(function () {
        let swiperEl = $(this)[0];
           const blockId = swiperEl.dataset.blockId;
           const slidesPerView = swiperEl.dataset.slidesPerView;
           let params = {
              navigation: {
                 prevEl: `.haj-swiper-slide-prev-${blockId}`,
                 nextEl: `.haj-swiper-slide-next-${blockId}`,
              },
              loop: true,
              breakpoints: {
                 640: {
                    slidesPerView: 1,
                 },
                 968: {
                    slidesPerView: slidesPerView,
                 },
              },
           };

           Object.assign(swiperEl, params);

           swiperEl.initialize();
     });
  }
})(jQuery);
